import { FILL, FIT } from 'consts/canvas'
import { COLORS } from 'consts/colors'

export interface IDimensions {
  width: number
  height: number
}

export type TScaleMode = typeof FIT | typeof FILL

export type TPosition = 'top' | 'right' | 'bottom' | 'left'

export type TColorKey = keyof typeof COLORS

export enum OverlayItemType {
  AI_IMAGE = 'aiImage',
  AI_VIDEO = 'aiVideo',
  IMAGE = 'image',
  MUSIC_VERSIONING = 'musicVersioning'
}

export type TOverlayItemType = OverlayItemType

export type TOverlayContent = Record<TOverlayItemType, React.ReactNode>
